// extracted by mini-css-extract-plugin
export default {"title":"TitleElement_title__snnw7","default":"TitleElement_default__siAtK"};